// 微信吸粉
import React from "react";
import { Card, Row } from "antd";

import Description from "./Description";

const ProQqNew2 = ({ proinfo, title }) => {
  const data = proinfo || {};
  return (
    <Card title="产品明细">
      <h3 className="order_pro_title">{title}</h3>
      <div style={{ paddingLeft: "50px" }}>
        <Row>
          <Description term="吸粉数量">{data.c_suckfans}</Description>
          <Description term="打款金额">{data.c_playmoney}</Description>
        </Row>
      </div>
    </Card>
  );
};

export default ProQqNew2;



// WEBPACK FOOTER //
// ./src/components/xianxing/order/ProFans.js